// libs/react-mosaic-component/src/lib/buttons/ReplaceButton.tsx
import classNames from "classnames";
import { noop } from "lodash-es";
import React from "react";
import { MosaicWindowContext } from "../contextTypes.mjs";
import { OptionalBlueprint } from "../util/OptionalBlueprint.mjs";
import { DefaultToolbarButton } from "./MosaicButton.mjs";
var ReplaceButton = class extends React.PureComponent {
  static contextType = MosaicWindowContext;
  render() {
    return /* @__PURE__ */ React.createElement(
      DefaultToolbarButton,
      {
        title: "Replace Window",
        className: classNames(
          "replace-button",
          OptionalBlueprint.getIconClass(
            this.context.blueprintNamespace,
            "EXCHANGE"
          )
        ),
        onClick: this.replace
      }
    );
  }
  replace = () => {
    this.context.mosaicWindowActions.replaceWithNew().then(() => {
      if (this.props.onClick) {
        this.props.onClick();
      }
    }).catch(noop);
  };
};
export {
  ReplaceButton
};
